import { fetchEmployee, updateEmployeeResearchStatus } from '@/api/business/employee'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

export const EmployeeKeys = {
    all: ['employee'] as const,
    lists: () => [...EmployeeKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...EmployeeKeys.lists(), page, perPage, filters] as const,
    details: () => [...EmployeeKeys.all, 'detail'] as const,
    detail: (params: string) => [...EmployeeKeys.details(), params] as const,
}

export const useEmployeeQuery = (SK_REVENDA: number, enableStatus: boolean) => {
    return useQuery({
        enabled: enableStatus && Boolean(SK_REVENDA),
        queryFn:  () => fetchEmployee(SK_REVENDA),
        queryKey: [...EmployeeKeys.lists(), SK_REVENDA],
    })
}

export const useUpdateEmployeeResearchStatusMutation = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: ({ SK_FUNCIONARIO, DD_PARTICIPA_PESQUISA }: { SK_FUNCIONARIO: string; DD_PARTICIPA_PESQUISA: number }) =>
            updateEmployeeResearchStatus(SK_FUNCIONARIO, DD_PARTICIPA_PESQUISA),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: EmployeeKeys.lists() })
        },
    })
}
